
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'snow': {
    width: 100,
    height: 100,
    viewBox: '0 0 100 100',
    data: '<path pid="0" fill-rule="evenodd" clip-rule="evenodd" d="M63.999 64.943v-4.381a7.993 7.993 0 0 0 3.999-6.922 8 8 0 0 0-7.999-7.998c-1.6 0-3.083.48-4.333 1.291-1.231-5.317-5.974-9.291-11.665-9.291-6.627 0-11.998 5.373-11.998 12 0 3.549 1.55 6.729 4 8.924v4.916c-4.777-2.768-8-7.922-8-13.84 0-8.836 7.163-15.999 15.998-15.999 6.004 0 11.229 3.312 13.965 8.204.664-.113 1.337-.205 2.033-.205 6.627 0 11.999 5.373 11.999 11.998 0 5.223-3.343 9.653-7.999 11.303zm-21.998-7.302a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 8a2 2 0 1 1 .001 3.999 2 2 0 0 1-.001-3.999zm8-4a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 7.998A2 2 0 1 1 50 73.64 2 2 0 0 1 50 69.64zm7.998-11.998a2 2 0 1 1 0 4 2 2 0 0 1 0-4zm0 8A2 2 0 1 1 58 69.64 2 2 0 0 1 58 65.64z"/>'
  }
})
